import { Static, Type } from '@sinclair/typebox'

export const AiBuilderResponseMessage = Type.Object({
    content: Type.String(),
    /** When present, content is a Tolgee i18n key and these are the interpolation params */
    contentParams: Type.Optional(Type.Record(Type.String(), Type.String())),
    /**
     * Free text written by the model, shown above `content` and NEVER
     * translated. It must stay a separate field: concatenated with `content`,
     * the whole string is no longer a key — so the key half rendered in English
     * with only its placeholders filled.
     */
    contentPrefix: Type.Optional(Type.String()),
})

export type AiBuilderResponseMessage = Static<typeof AiBuilderResponseMessage>
